/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseDiningTableDto } from '../../models/api-response-dining-table-dto';
import { DiningTableDto } from '../../models/dining-table-dto';

export interface CreateDiningTable$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: DiningTableDto
}

export function createDiningTable(http: HttpClient, rootUrl: string, params: CreateDiningTable$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDiningTableDto>> {
  const rb = new RequestBuilder(rootUrl, createDiningTable.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseDiningTableDto>;
    })
  );
}

createDiningTable.PATH = '/v1/api/dining-tables/create';
